import * as Sentry from '@sentry/vue'
import { sentryDeniedUrls, sentryIgnoredErrors } from '~/config/sentry/ignoredErrors'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  const dsn = config.public.sentryDsn
  const enabled = config.public.sentryEnabled === 'true' || config.public.sentryEnabled === true

  if (!dsn || !enabled) {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn,
    release: config.public.sentryRelease || 'mansion-app@unknown',
    environment: config.public.sentryEnvironment || 'development',
    integrations: [
      Sentry.browserTracingIntegration({ router: nuxtApp.$router }),
    ],
    tracesSampleRate: Number(config.public.sentryTracesSampleRate ?? 1.0),
    ignoreErrors: sentryIgnoredErrors,
    denyUrls: sentryDeniedUrls,
    sendDefaultPii: false,
  })
})
